export default function(value, length = 8, chr = '0') {
  while (value.length < length) {
    value = chr + value;
  }
  return value;
}
